module.exports = __webpack_public_path__ + "img/katarina_events_20.38e15f13.jpg";